import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { SplitButtonModule } from 'primeng/splitbutton';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ChipsModule } from 'primeng/chips';
import { AccordionModule } from 'primeng/accordion';
import { CheckboxModule } from 'primeng/checkbox';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { ToastModule } from 'primeng/toast';
import { CalendarModule } from 'primeng/calendar';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ListboxModule } from 'primeng/listbox';
import { FieldsetModule } from 'primeng/fieldset';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { SidebarModule } from 'primeng/sidebar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CarouselModule } from 'primeng/carousel';
import { GalleriaModule } from 'primeng/galleria';
import { EditorModule } from 'primeng/editor';
import { PanelMenuModule } from 'primeng/panelmenu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TreeModule } from 'primeng/tree';
import { ChartModule } from 'primeng/chart';
import { TabMenuModule } from 'primeng/tabmenu';
import { BadgeModule } from 'primeng/badge';
import { MenuModule } from 'primeng/menu';
import { RatingModule } from 'primeng/rating';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ChipModule } from 'primeng/chip';
import { TimelineModule } from 'primeng/timeline';
import { NgModule } from '@angular/core';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { StepsModule } from 'primeng/steps';
import { DividerModule } from 'primeng/divider';
import { FixTooltipWidthModule } from './primeng/fix-tooltip-width/fix-tooltip-width.directive';
import { PaginatorModule } from 'primeng/paginator';

const PRIMENG_MODULES = [
  FixTooltipWidthModule,
  ToolbarModule,
  ButtonModule,
  SplitButtonModule,
  InputTextModule,
  InputTextareaModule,
  InputNumberModule,
  TableModule,
  TabViewModule,
  DialogModule,
  FileUploadModule,
  DropdownModule,
  MultiSelectModule,
  AutoCompleteModule,
  ChipsModule,
  AccordionModule,
  CheckboxModule,
  TriStateCheckboxModule,
  ToastModule,
  CalendarModule,
  TagModule,
  TooltipModule,
  InputSwitchModule,
  ListboxModule,
  FieldsetModule,
  BreadcrumbModule,
  SidebarModule,
  RadioButtonModule,
  CarouselModule,
  GalleriaModule,
  EditorModule,
  PanelMenuModule,
  OverlayPanelModule,
  TreeModule,
  ChartModule,
  TabMenuModule,
  BadgeModule,
  MenuModule,
  RatingModule,
  SelectButtonModule,
  ProgressSpinnerModule,
  ChipModule,
  TimelineModule,
  DynamicDialogModule,
  ProgressBarModule,
  StepsModule,
  DividerModule,
  PaginatorModule,
];
@NgModule({
  imports: [...PRIMENG_MODULES],
  exports: [...PRIMENG_MODULES],
})
export class PrimengModule {}
